import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, CircularProgress } from "@mui/material";

import { loadCurrentSession, selectUser } from "store/slices/app";
import { signOut } from "store/slices/authPages";
import * as authApi from "api/endpoints/auth";
import useIdleTimer from "../../utils/useIdleTimer";
import SessionExpired from "../../components/common/SessionExpired";

const AuthGaurd = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;

  const user = useSelector(selectUser);
  const isIdle = useIdleTimer(1000 * 60 * 30);
  const navigate = useNavigate();

  useEffect(() => {
    if (user == null) {
      dispatch(loadCurrentSession(currentPath));
    }
  }, [dispatch, user, currentPath]);

  useEffect(() => {
    if (isIdle) {
      authApi.signOut();
    }
  }, [isIdle]);

  function handleSignIn() {
    dispatch(signOut());
    navigate("/sign-in");
  }

  return (
    <>
      {user?.selectedPartner ? (
        props.children
      ) : (
        <Box top="47%" left="47%" position="absolute">
          <CircularProgress />
        </Box>
      )}
      <SessionExpired show={isIdle} onClick={handleSignIn} />
    </>
  );
};

export default AuthGaurd;
